import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const headerHeight = 0;

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: headerHeight  // ← headerの高さを使う
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

/*----------------------------------------
  ヘッダー動き
------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const mainSection = document.querySelector('.main');

  if (!header || !mainSection) return;

  let scrollHandler = null;

  const handleScroll = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight;
    const threshold = viewportHeight - 250;

    if (scroll > threshold) {
      header.classList.add('is_fixed');
    } else {
      header.classList.remove('is_fixed');
    }
  };

  const updateScrollEvent = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const mainTop = mainSection.offsetTop;

    // 画面幅が1024以上かつ main の上端が画面の一番上に来たらスクロールイベントを有効化
    if (window.innerWidth >= 1024 && scroll >= mainTop) {
      if (!scrollHandler) {
        scrollHandler = handleScroll;
        window.addEventListener('scroll', scrollHandler);
        handleScroll(); // 初回判定
      }
    } else {
      // 画面幅が1024未満、または main の上端前 → イベント削除
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
        header.classList.remove('is_fixed');
      }
    }
  };

  // 初回実行
  updateScrollEvent();

  // スクロール時に main 上端判定
  window.addEventListener('scroll', updateScrollEvent);

  // リサイズ時にも判定
  window.addEventListener('resize', updateScrollEvent);
});

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');
let nav_box = document.querySelector('.hd_nav_box');

if (button && nav_box) {
  button.addEventListener('click', function() {

    if (nav_box.classList.contains('is_open')) {
      nav_box.classList.remove("is_open");
      button.classList.remove("is_close");
    } else {
      nav_box.classList.add("is_open");
      button.classList.add("is_close");
    }

  });
}

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});

// /*----------------------------------------
// お問い合わせバリデーション
// ------------------------------------------*/
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


/*----------------------------------------
カレント設定
------------------------------------------*/

if (body.classList.contains("home")) {
  (function() {
    // DOMContentLoaded に変えることで、より早く確実に実行させます
    window.addEventListener('DOMContentLoaded', () => {
      const homeLink = document.querySelector('.hd_nav_list:nth-of-type(1) .hd_nav_link');
      const infoLink = document.querySelector('.js-nav-info');
      const infoSection = document.getElementById('info');
      const allLinks = document.querySelectorAll('.hd_nav_link');
      const currentClass = 'is_active';
      const path = window.location.pathname;

      const resetActive = () => allLinks.forEach(link => link.classList.remove(currentClass));

      // トップページ判定（空文字、/、index.html のいずれか）
      const isTopPage = path === '/' || path.endsWith('/') || path.includes('index');

      if (!isTopPage) {
        resetActive();
        if (path.includes('recomend')) document.querySelector('.hd_nav_list:nth-of-type(2) .hd_nav_link')?.classList.add(currentClass);
        if (path.includes('news')) document.querySelector('.hd_nav_list:nth-of-type(3) .hd_nav_link')?.classList.add(currentClass);
        return;
      }

      // --- トップページ用の処理 ---

      // 監視を開始する前に、まず一度リセットしてHOMEをつける
      resetActive();
      homeLink?.classList.add(currentClass);

      if (infoSection && infoLink && homeLink) {
        const observerOptions = {
          root: null,
          // 画面の上部 20% 〜 下部 20% の間にセクションが入ったら検知
          rootMargin: '-20% 0px -20% 0px',
          threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            // IntersectionObserverは初期読み込み時にも一度実行されます
            if (entry.isIntersecting) {
              // 店舗案内が画面内に入った
              homeLink.classList.remove(currentClass);
              infoLink.classList.add(currentClass);
            } else {
              // 店舗案内が画面外（上か下）にいる
              infoLink.classList.remove(currentClass);
              homeLink.classList.add(currentClass);
            }
          });
        }, observerOptions);

        observer.observe(infoSection);
      }
    });
  })();
 }

/*----------------------------------------
要素アニメーション
------------------------------------------*/
const item = document.querySelectorAll('.scrollAnim');
item.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 90%",
    onEnter: () => target.classList.add('active'), // その要素自身にクラスを付ける
  });
});